import site from '../../site';
import globals from '../../globals';
import customization from '../../customization';
import initialData from './initial-data';

const actualizeInitialData = (state) => {
  const pages = site.selectors.getPages(state);
  const globalList = globals.selectors.getGlobals(state);
  const activePageId = site.selectors.getActivePageId(state);
  const settingsList = site.selectors.getSettings(state);
  const siteProperties = site.selectors.getSiteProperties(state);
  const siteName = site.selectors.getSiteName(state);
  const cleanUrlsEnabled = site.selectors.getCleanUrlsEnabled(state);
  const customColorPalettes = customization.selectors.getCustomColorPalettes(state);
  const currentColorPaletteVersion = customization.selectors.getCurrentColorPaletteVersion(state);
  const currentCustomTextColors = customization.selectors.getCustomTextColors(state);
  const currentCustomColors = customization.selectors.getCustomColors(state);
  const redirects = site.selectors.getRedirects(state);
  const integrations = site.selectors.getIntegrations(state);
  const currentButtonPresetVersion = customization.selectors.getCurrentButtonPresetVersion(state);

  initialData.setPages(pages);
  initialData.setGlobals(globalList);
  initialData.setActivePageId(activePageId);
  initialData.setSettings(settingsList);
  initialData.setProperties(siteProperties);
  initialData.setSiteName(siteName);
  initialData.setCustomColorPalettes(customColorPalettes);
  initialData.setCurrentColorPaletteVersion(currentColorPaletteVersion);
  initialData.setCustomTextColors(currentCustomTextColors);
  initialData.setCustomColors(currentCustomColors);
  initialData.setCleanUrlsEnabled(cleanUrlsEnabled);
  initialData.setRedirects(redirects);
  initialData.setIntegrations(integrations);
  initialData.setCurrentButtonPresetVersion(currentButtonPresetVersion);
};

export default actualizeInitialData;
